import React from 'react';

import PropTypes from 'prop-types';

import { sitename } from '../../../config';
import Layout from '../layouts/Layout';
import Body from '../modules/Body';
import EmptySpace from '../modules/EmptySpace';
import Footer from '../modules/Footer';
import Header from '../modules/Header';

class PropertyManagerInvite extends React.Component {
  static propTypes = {
    content: PropTypes.shape({
      link: PropTypes.string.isRequired,
      InviterName: PropTypes.string.isRequired,
      // name: PropTypes.string.isRequired,
    }),
  };

  render() {
    const buttonStyle = {
      margin: 0,
      fontFamily: 'Arial',
      padding: '10px 16px',
      textDecoration: 'none',
      borderRadius: '2px',
      border: '1px solid',
      textAlign: 'center',
      verticalAlign: 'middle',
      fontWeight: 'normal',
      fontSize: '18px',
      whiteSpace: 'nowrap',
      background: '#ffffff',
      borderColor: '#ff5a5f',
      backgroundColor: '#ff5a5f',
      color: '#ffffff',
      borderTopWidth: '1px',
    };

    const textStyle = {
      color: '#484848',
      backgroundColor: '#F7F7F7',
      fontFamily: 'Arial',
      fontSize: '16px',
      padding: '35px',
    };
    // const { content: { link, name, InviterName, referralKey } } = this.props;
    const {
      content: { name, email, password, loginURL },
    } = this.props;

    // let referralURL = url + '/c/' + referralKey + '/' + email;
    let referralURL;

    return (
      <Layout>
        <Header backgroundColor="#F7F7F7" color="rgb(255, 90, 95)" />
        <Body textStyle={textStyle}>
          <div>
            {!name && <div>Hello,</div>}
            {name && <div>Hi {name},</div>}
          </div>
          <EmptySpace height={20} />
          <div>
            Admin added you as a property manager in Golightly, the exclusive
            members-only home sharing and vacation rental network for
            professional females.
          </div>
          <EmptySpace height={10} />
          <div>Your email and password are below:</div>
          <EmptySpace height={10} />
          <div>Email: {email}</div>
          <EmptySpace height={10} />
          <div>Password: {password}</div>
          <EmptySpace height={10} />
          <div>Please use the link below to log in</div>

          <div>
            <a href={loginURL}>{loginURL}</a>
          </div>
          <EmptySpace height={20} />
          <div>Thanks,</div>
          <EmptySpace height={20} />
          <div>The {sitename} Team</div>
        </Body>
        <Footer />
        <EmptySpace height={20} />
      </Layout>
    );
  }
}

export default PropertyManagerInvite;
